export default {
  default : '0px 4px 12px rgba(0, 0, 0, 0.27);',
};
